import { THEMES } from './themeConstants';

export const getThemeInitialisedSelector = (state) => state.getIn(['app', 'theme', 'initialised']);
export const getThemeSelector = (state) => state.getIn(['app', 'theme', 'theme']);
export const getThemeModeSelector = (state) => state.getIn(['app', 'theme', 'mode']);

export const getThemeIsDarkMode = (state) => getThemeSelector(state) === THEMES.DARK;
